import {Link, useLocation} from 'react-router-dom';
import BlueEyeIcon from '../../../assets/icons/blueEye.svg';
import './style.scss';

const ADVISOR_PHASE_BY_TYPE = {
    COP_SOLICITUD: 'solicitud',
    COP_PLANEACION: 'planeacion',
    COP_DESARROLLO: 'desarrollo',
    COP_CIERRE: 'cierre'
};

function MeetingRow({school, meetingGroup}) {
    const location = useLocation();
    const returnTo = `${location.pathname}${location.search}`;
    const attendanceDetailQuery = new URLSearchParams({
        encuentro: String(meetingGroup?.id ?? ''),
        origin: 'admin-attendances',
        returnTo
    });
    const advisorPhase = ADVISOR_PHASE_BY_TYPE[
        String(meetingGroup?.type || '').trim().toUpperCase()
    ];
    if (advisorPhase) {
        attendanceDetailQuery.set('phase', advisorPhase);
        attendanceDetailQuery.set('order', String(meetingGroup?.order ?? ''));
    }
    const attendanceDetailPath = `/escuelas/grupo/lista_de_encuentros/encuentro?${attendanceDetailQuery.toString()}`;

    function setDate(meetingDate){
        if (meetingDate) {
            const index = meetingDate.indexOf('T');
            if (index !== -1) {
                return meetingDate.substring(0, index);
            }
        }
        return '';
    }

    const mediatorName = meetingGroup?.mediatorName ?? school?.user?.full_name ?? '';
    const groupName = meetingGroup?.groupName || '-';

    return (
        <div className='info-container'>
            <p className='meeting-option'>{school?.code}</p>
            <p className='meeting-option'>{groupName}</p>
            <p className='meeting-option'>{meetingGroup?.meetingName}</p>
            <p className='meeting-option'>{mediatorName}</p>
            <p className='meeting-option'>{meetingGroup?.id}</p>
            <p className='meeting-option'>{setDate(meetingGroup?.meeting_date ?? meetingGroup?.meetingDate)}</p>
            <p className='meeting-option row-item'>
                <Link
                    className='attendance-action-button'
                    to={attendanceDetailPath}
                    state={{ backTo: returnTo }}>
                    <img src={BlueEyeIcon} alt='Ver asistencia' />
                </Link>
                <Link
                    className='attendance-action-button'
                    to={`/generar-listado-asistencia?evento_id=${meetingGroup?.id ?? ''}`}
                    state={{ backTo: returnTo }}>
                    <span className='material-symbols-rounded' title='Listado oficial de asistencia'>
                        print
                    </span>
                </Link>
            </p>
        </div>
    );
}

export default MeetingRow;
